export const VOLUME_INPUT_TYPES = {
  purchase_shift: {
    errorText: 'Upper threshold must be greater than lower threshold',
    helperText: '',
    higherHint: '',
    higherTitle: 'UPPER THRESHOLD',
    lowerHint: '',
    lowerTitle: 'LOWER THRESHOLD',
  },
  purchase_volume: {
    errorText: 'Heavy must be greater than light',
    helperText: '* Medium buyers will be automatically calculated.',
    higherHint: 'Greater than the value of',
    higherTitle: 'HEAVY',
    lowerHint: 'Less than the value of',
    lowerTitle: 'LIGHT',
  },
};
